import { ApplicationView } from 'ohzi-core';

import { Sections, SectionsURLs } from './Sections';

export default class HomeView extends ApplicationView
{
  constructor()
  {
    super({
      name: Sections.HOME,
      url: SectionsURLs.HOME,
      container: document.querySelector('.map3d-home')
    });
  }

  // This method is called one time at the beginning of the app execution.
  start()
  {
    this.card = document.querySelector('.map3d-home__container');
    this.title = document.querySelector('.map3d-card__title');
    this.subtitle = document.querySelector('.map3d-card__subtitle');
    this.text = document.querySelector('.map3d-card__text');
    this.image = document.querySelector('.map3d-card__image');
    this.back_button = document.querySelector('.map3d-home__back-button');
    this.url = document.querySelector('.map3d-card__subtitle__url');
  }

  // This method is called one time before the transition to this section is started.
  before_enter()
  {
  }

  // This method is called one time after the transition to this section is finished.
  on_enter()
  {
    super.on_enter();
    this.hide();
  }

  // This method is called one time before the transition to the next section is started.
  before_exit()
  {
    super.before_exit();
  }

  // This method is called one time after this section is completely hidden.
  on_exit()
  {
  }

  // This method is called in every frame right after on_enter is called.
  update()
  {
  }

  // This method is called in every frame when the site is transitioning to this section.
  update_transition(global_view_data, transition_progress)
  {
  }

  // CUSTOM METHODS

  update_text({ title, subtitle, text })
  {
    this.title.innerHTML = title;
    this.subtitle.innerHTML = subtitle;
    this.text.innerHTML = text;
  }

  set_callback(callback)
  {
    this.on_close_callback = callback;
  }

  set_back_callback(callback)
  {
    this.on_back_callback = callback;
  }

  update_card({ title, subtitle, text, img_slug, url })
  {
    this.title.innerHTML = title;
    this.subtitle.innerHTML = subtitle;
    this.text.innerHTML = text;
    this.image.src = img_slug;
    this.url.href = url;
  }

  hide(callback = console.error)
  {
    super.hide();
    callback();
    if (this.on_close_callback) this.on_close_callback();
  }

  hide_back_button()
  {
    if(!this.card) return;
    this.card.classList.remove('hidden');
    this.back_button.classList.add('hidden');
    //super.hide();
    if (this.on_close_button_callback) this.on_close_callback();
  }

  show_back_button(callback2 = () => console.error('no callback provided'))
  {
    this.on_close_button_callback = callback2;
    this.back_button.classList.remove('hidden');
    //super.show();
  }
}
